<ng-container [ngSwitch]="type">
  <app-widget-number
    *ngSwitchCase="'NUMBER'"
    [widget]="previewWidget"
    [showChrome]="false"
    [displayType]="'NUMBER'"
    [typeLabel]="'Última lectura'"
    [sourceLabel]="'Vista previa'">
  </app-widget-number>

  <app-widget-number
    *ngSwitchCase="'GAUGE'"
    [widget]="previewWidget"
    [showChrome]="false"
    [displayType]="'GAUGE'"
    [typeLabel]="'Gauge'"
    [sourceLabel]="'Vista previa'">
  </app-widget-number>

  <app-widget-line-chart
    *ngSwitchCase="'LINE'"
    [widget]="previewWidget"
    [isPreview]="true"
    [showChrome]="false"
    [typeLabel]="'Línea'"
    [sourceLabel]="'Vista previa'">
  </app-widget-line-chart>

  <app-widget-line-chart
    *ngSwitchCase="'AREA'"
    [widget]="previewWidget"
    [isPreview]="true"
    [showChrome]="false"
    [typeLabel]="'Area'"
    [sourceLabel]="'Vista previa'">
  </app-widget-line-chart>

  <app-widget-bar-chart
    *ngSwitchCase="'BAR'"
    [widget]="previewWidget"
    [isPreview]="true"
    [showChrome]="false"
    [typeLabel]="'Barra'"
    [sourceLabel]="'Vista previa'">
  </app-widget-bar-chart>

  <app-widget-device-list
    *ngSwitchCase="'DEVICE_LIST'"
    [widget]="previewWidget"
    [showChrome]="false"
    [typeLabel]="'Lista'"
    [sourceLabel]="'Vista previa'">
  </app-widget-device-list>

  <app-widget-map
    *ngSwitchCase="'MAP'"
    [widget]="previewWidget"
    [isPreview]="true">
  </app-widget-map>
</ng-container>
